export default function ExecutiveRecommendationPanel({
  label,
  description,
  recommendation,
  metricLabel,
  metricValue,
  tone = "neutral",
}) {
  const toneStyles = {
    success: "bg-green-50 border-green-200 text-green-900",
    warning: "bg-amber-50 border-amber-200 text-amber-900",
    danger: "bg-red-50 border-red-200 text-red-900",
    info: "bg-blue-50 border-blue-200 text-blue-900",
    neutral: "bg-slate-50 border-slate-200 text-slate-900",
  };

  return (
    <section className={`rounded-2xl border p-5 ${toneStyles[tone]}`}>
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
        <div className="lg:col-span-2">
          <h3 className="text-lg font-semibold">
            {label}
          </h3>

          {description && (
            <p className="text-sm mt-2 leading-relaxed text-slate-700">
              {description}
            </p>
          )}
        </div>

        {metricLabel && (
          <div>
            <p className="text-xs uppercase tracking-wide text-slate-500">
              {metricLabel}
            </p>

            <p className="text-2xl font-bold text-slate-900 mt-1">
              {metricValue}
            </p>
          </div>
        )}

        {recommendation && (
          <div>
            <p className="text-xs uppercase tracking-wide text-slate-500">
              Recommendation
            </p>

            <p className="mt-2 text-sm leading-relaxed text-slate-800 font-semibold">
              {recommendation}
            </p>
          </div>
        )}
      </div>
    </section>
  );
}